import { alpha, Box, Stack, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { formatDate, getRelativeTime, isBeforeToday, isValidDate } from '../../../../../util/date';

interface DueDateSectionProps {
    isEditing: boolean;
    editedDueDate: Dayjs | null;
    setEditedDueDate: (value: Dayjs | null) => void;
    isCompleted: boolean;
    dueDate?: Dayjs;
}

export const DueDateSection = ({
    isEditing,
    editedDueDate,
    setEditedDueDate,
    isCompleted,
    dueDate,
}: DueDateSectionProps) => {
    if (!dueDate && !isEditing) return null;
    const isOverdue = dueDate && isBeforeToday(dueDate.toString());

    return (
        <Box sx={{ mb: 3 }}>
            <Typography color="text.secondary" variant="subtitle2" gutterBottom>
                Due Date
            </Typography>
            {isEditing ? (
                <DateTimePicker
                    value={editedDueDate}
                    onChange={(newValue) => setEditedDueDate(newValue)}
                    slotProps={{
                        textField: {
                            size: 'small',
                            fullWidth: true,
                            sx: { bgcolor: 'background.paper' }
                        },
                        actionBar: {
                            actions: ['clear', 'cancel', 'accept']
                        }
                    }}
                />
            ) : dueDate && isValidDate(dueDate) ? (
                <Stack direction="row" spacing={1} sx={{
                    bgcolor: (theme) => isOverdue && !isCompleted ? alpha(theme.palette.error.light, 0.1) : theme.palette.background.paper,
                    p: isOverdue && !isCompleted ? 1 : 0,
                    borderRadius: 1,
                }}>
                    <Typography sx={{
                        color: (theme) => isOverdue && !isCompleted ? alpha(theme.palette.error.main, 0.5) : "text.primary"
                    }}>
                        {formatDate(dueDate.toString(), true)}
                    </Typography>
                    <Typography sx={{
                        color: (theme) => isOverdue && !isCompleted ? alpha(theme.palette.error.main, 0.5) : "text.secondary"
                    }}>
                        {getRelativeTime(dueDate.toString())} {isOverdue ? '' : 'left'}
                    </Typography>
                </Stack>
            ) : null
            }
        </Box >
    );
}; 